import React from 'react';

function FeaturesBlocks() {
  return (
    <section className="relative">

      {/* Section background (needs .relative class on parent and next sibling elements) */}
      <div className="absolute inset-0 top-1/2 md:mt-24 lg:mt-0 bg-gray-900 pointer-events-none" aria-hidden="true"></div>
      <div className="absolute left-0 right-0 bottom-0 m-auto w-px p-px h-20 bg-gray-200 transform translate-y-1/2"></div>

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6">
        <div className="py-12 md:py-20">

          {/* Section header */}
          <div className="max-w-3xl mx-auto text-center pb-12 md:pb-20">
            <h2 className="h2 mb-4">Getting started</h2>
            <p className="text-xl text-gray-600">
              <a className="text-blue-600 hover:underline" href="/#subscribe">
                Sign up below
              </a>
              &nbsp;and we will let you know once RetroEasy is live!
            </p>
          </div>

          {/* Items */}
          <div className="max-w-sm mx-auto grid gap-6 md:grid-cols-2 lg:grid-cols-3 items-start md:max-w-2xl lg:max-w-none">

            {/* 1st item */}
            <div className="relative flex flex-col items-center p-6 bg-white rounded shadow-xl">
              <div className="features-block-icon-div">
                <img src={require('../images/newsletter.png').default} className="features-block-icon-img" width="32" height="32" alt="First step is to subscribe to our newsletter" />
              </div>
              <h4 className="text-xl font-bold leading-snug tracking-tight mb-1">Subscribe</h4>
              <p className="text-gray-600 text-center">
                Enter in your email address&nbsp;
                <a className="text-blue-600 hover:underline" href="/#subscribe">
                  below
                </a>
                &nbsp;to subscribe to our email newsletter!
              </p>
            </div>

            {/* 2nd item */}
            <div className="relative flex flex-col items-center p-6 bg-white rounded shadow-xl">
              <div className="features-block-icon-div">
                <img src={require('../images/notification.png').default} className="features-block-icon-img" width="32" height="32" alt="Second step is to be on the lookout for an email that states that we are live" />
              </div>
              <h4 className="text-xl font-bold leading-snug tracking-tight mb-1">Launch day</h4>
              <p className="text-gray-600 text-center">We will let you know as soon as we are live!</p>
            </div>

            {/* 3rd item */}
            <div className="relative flex flex-col items-center p-6 bg-white rounded shadow-xl">
              <div className="features-block-icon-div">
                <img src={require('../images/add-user.png').default} className="features-block-icon-img" width="32" height="32" alt="Third step is to create an account on our platform and you should be on your way" />
              </div>
              <h4 className="text-xl font-bold leading-snug tracking-tight mb-1">Sign up</h4>
              <p className="text-gray-600 text-center">Create an account and starting using RetroEasy!</p>
            </div>

          </div>

        </div>
      </div>
    </section>
  );
}

export default FeaturesBlocks;
